import { render, staticRenderFns } from "./roadbooklist.vue?vue&type=template&id=286612a4&scoped=true"
import script from "./roadbooklist.vue?vue&type=script&lang=js"
export * from "./roadbooklist.vue?vue&type=script&lang=js"
import style0 from "./roadbooklist.vue?vue&type=style&index=0&id=286612a4&prod&lang=scss"
import style1 from "./roadbooklist.vue?vue&type=style&index=1&id=286612a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286612a4",
  null
  
)

export default component.exports